import { Suspense } from "react"
import { Navigate } from "react-router-dom"

import { useTranslation } from "@/hooks/useTranslation"
import { HeaderPage } from "@/organisms/HeaderPage"
import { LoaderFallback } from "@/pages/DiscoveryPage/components/molecules/LoaderFallback"
import { useScanHistoryFeatureFlags } from "@/pages/GovernancePage/applications/scan-history/useScanHistory"
import { PageTemplate } from "@/templates/PageTemplate"
import ScanHistoryTab from "./components/ScanHistoryTab"

export const ScanHistoryPage = () => {
  const { t } = useTranslation()
  const { enabled, initialize } = useScanHistoryFeatureFlags()

  if (!initialize) return <LoaderFallback />

  if (!enabled) return <Navigate to="/" />

  return (
    <PageTemplate
      full
      header={<HeaderPage titleTranslationKey={t("navigation.scanHistory")} />}
    >
      <Suspense fallback={<LoaderFallback />}>
        <ScanHistoryTab />
      </Suspense>
    </PageTemplate>
  )
}
